import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Icons } from '../../../../shared/helpers/icons';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { FunctionService } from '../../../../shared/services/function.service';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'function-edit',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    LucideAngularModule,
    SpinnerComponent,
    NoEmojiDirective
  ],
  templateUrl: './function-edit.component.html',
  styleUrl: './function-edit.component.css'
})
export class FunctionEditComponent implements OnInit, OnChanges {
  icons = Icons;
  functionForm: FormGroup = new FormGroup({});
  loading: boolean = false;
  @Input() functionToEdit: any | null = null;
  
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  constructor( private functionService: FunctionService ) {}

  ngOnInit(): void {
    console.log(this.functionToEdit)
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['functionName'] && this.functionToEdit) {
      this.initializeForm(); 
    }
  }

  private initializeForm(): void {
    this.functionForm = new FormGroup({
      function_name: new FormControl(this.functionToEdit.function_name, Validators.required),
      goal_before_description: new FormControl(this.functionToEdit.goals[0]?.goal_description || '', Validators.required),
      goal_before_objective: new FormControl(this.functionToEdit?.goals[0]?.objective || '', Validators.required),
      goal_during_description: new FormControl(this.functionToEdit?.goals[1]?.goal_description || '', Validators.required),
      goal_during_objective: new FormControl(this.functionToEdit?.goals[1]?.objective || '', Validators.required),
      goal_after_description: new FormControl(this.functionToEdit?.goals[2]?.goal_description || '', Validators.required),
      goal_after_objective: new FormControl(this.functionToEdit?.goals[2]?.objective || '', Validators.required)
    });
  }

  onSubmit(): void {
    if (this.functionForm.valid && this.functionToEdit) {
      // Structure the final object as per the desired format
      const formValue = this.functionForm.value;
      const goals = [
        {
          goal_type: 1,
          goal_description: formValue.goal_before_description,
          objective: formValue.goal_before_objective
        },
        {
          goal_type: 2,
          goal_description: formValue.goal_during_description,
          objective: formValue.goal_during_objective
        },
        {
          goal_type: 3,
          goal_description: formValue.goal_after_description,
          objective: formValue.goal_after_objective
        }
      ];
      const finalData = {
        function_name: formValue.function_name,
        goals: goals
      };
      
      this.loading = true;
      this.functionService.editFunction(finalData, this.functionToEdit.id).subscribe({
        next: (response) => {
          this.loading = false;
          if (!response.has_error) {
            this.onSave.emit({ type: 'success', message: 'This occurred after updating function goals and objectives.' });
          }
          console.log(response);
        },
        error: (error) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: error.message });
        }
      })
    }
  }

  closeEdit(): void {
    this.onClose.emit();
  }
}
